import { useEffect } from 'react'

import { Layout } from '../../components'
import { BypassCustomersPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

/**
 * @description Renders the Bypass List Page
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered BypassCustomersPage.
 */
const BypassCustomersPage = () => {

    useEffect(() => {
        document.title = 'Clientes em Exceção | LCD'
    }, [])

    return (
        <Layout selectedKey={DRAWER_KEYS.BYPASS_LIST}>
            <BypassCustomersPanel />
        </Layout>
    )
}

export default BypassCustomersPage
